
import { cn } from "@/lib/utils";

interface IntroSlideProps {
  title: string;
  description: string;
  className?: string;
  backgroundImage?: string;
}

const IntroSlide = ({ title, description, className, backgroundImage }: IntroSlideProps) => {
  return (
    <div 
      className={cn(
        "relative min-h-[100vh] flex items-center justify-center overflow-hidden",
        className
      )}
    >
      {/* Fondo con imagen y overlay */}
      <div 
        className="absolute inset-0 z-0 transition-opacity duration-700 ease-in-out"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.4,
        }}
      />

      {/* Contenido */}
      <div className="relative z-20 space-y-6 text-center px-6 animate-fade-in max-w-sm mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white">
          {title.includes("Clubbers") 
            ? <>
                {title.split("Clubbers")[0]}
                <span style={{ fontFamily: "'Zen Dots', cursive" }}>Clubbers</span>
                {title.split("Clubbers")[1]}
              </>
            : title}
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-white/90">
          {description}
        </p>
      </div>
    </div>
  );
};

export default IntroSlide;
